import axios, { AxiosResponse } from 'axios';
import { OwnerType } from 'types/shared/owner-type.enum';

// DELETE
// /ewosapi/v2/planandprognosis/default-profile/fishgroup/{fishGroupId}
// /ewosapi/v2/planandprognosis/default-profile/site/{globalSiteId}
export const deleteDefaultFishGroupProfile = async (owner: OwnerType, id: string): Promise<AxiosResponse> => {
  return await axios.delete<AxiosResponse>(`/ewosapi/v2/planandprognosis/default-profile/${owner}/${id}`);
};
